import _ from 'lodash';
import cookie from 'js-cookie';
import Env from './env';

const setCookie = (name, value, day = 1, domain = '', path = '') => {
  const Days = day || 30;
  const exp = new Date();

  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${escape(value)};expires=${exp.toUTCString()}${path ? (`;path=${path}`) : ';path=/'}${domain ? (`;domain=${domain}`) : ''}`;
};

const loginUrl = 'https://m.mgtv.com/login';
class LoginSDK {
  checkAppLogin() {
    const self = this;
    return new Promise((resolve) => {
      const { MgtvApi } = window;
      if (MgtvApi) {
        MgtvApi.getUserInfo((data) => {
          try {
            const result = JSON.parse(data);
            if (_.has(result, 'ticket')) {
              const ticket = _.get(result, 'ticket');
              const uuid = _.get(result, 'uuid');
              self.setCookies(uuid, ticket);
              resolve(!!ticket);
            } else {
              resolve(false);
            }
          } catch (e) {
            console.error(e);
            resolve(false);
          }
        });
      } else {
        resolve(false);
      }
      setTimeout(() => {
        resolve(false);
      }, 3000);
    });
  }

  setCookies(uuid, ticket) {
    if (uuid && ticket) {
      setCookie('uuid', uuid, 1, '.mgtv.com');
      setCookie('HDCN', ticket, 1, '.mgtv.com');
      setCookie('ticket', ticket, 1, '.mgtv.com');
      // cookie.set('uuid', uuid, '.mgtv.com')
      // cookie.set('HDCN', ticket, '.mgtv.com')
      // cookie.set('ticket', ticket, '.mgtv.com')

      // cookie.set('uuid', uuid, '.imgo.tv')
      // cookie.set('HDCN', ticket, '.imgo.tv')
      // cookie.set('ticket', ticket, '.imgo.tv')

      console.log(`写入uuid:${uuid}`);
      console.log(`写入ticket:${ticket}`);
    }
  }

  login(onSuccess) {
    if (Env.isMgtvApp) {
      this.appLogin(onSuccess);
    } else {
      this.webLogin();
    }
  }

  appLogin(onSuccess) {
    if (window.MgtvApi) {
      window.MgtvApi.login((data) => {
        if (onSuccess) {
          console.log(data);
        } else {
          window.location.reload();
        }
      });
    }
  }

  webLogin() {
    this.clearCookie();
    this.linkToActServerWithTarget(loginUrl);
  }

  logout() {
    if (!Env.isMgtvApp) {
      this.clearCookie();
      window.location.reload();
      // this.linkToActServerWithTarget(loginUrl);
    }
  }

  clearCookie() {
    ['ticket', 'uuid', 'HDCN'].forEach((key) => {
      cookie.remove(key, {
        domain: '.mgtv.com',
      });
      cookie.remove(key, {
        domain: '.imgo.tv',
      });
    });
  }

  linkToActServerWithTarget(url) {
    const target = new URL(url);
    target.searchParams.append('from', location.href);
    target.searchParams.append('app_id', 'h5_act');
    location.href = target.toString();
  }
}

export default new LoginSDK();
